import { Button, Typography } from "@mui/material";
import * as React from "react";
import "./CustomButton.css";
import { CustomButtonStyle } from "./CustomButtonStyle";
import { upperCase } from "lodash";

export default function CustomButtonColor({
  id,
  Icon,
  title,
  Input,
  onClick,
  EndIcon,
  disable,
  color,
  bgColor,
  borderRadius,
  borderColor,
  size
}) {
  return (
    <CustomButtonStyle
      variant="contained"
      component="label"
      id={id}
      onClick={onClick}
      disable={disable}
      sx={{
        minWidth: "150px",
        textAlign: "center",
        marginLeft: "0 !important",
        borderRadius: borderRadius ?? "17px",
        fontWeight: 500,
        border: borderColor + "1px solid",
        backgroundColor: bgColor,
        color: color,
        ":hover": {
          backgroundColor: bgColor,
          fontWeight: "bold",
        }
      }}
      // className="responsive-button"
      size={size ? size : "medium"}
      startIcon={<>{Icon}</>}
      endIcon={<>{EndIcon}</>}
    >
      <Typography
        // className="responsive-button"
        textTransform={"initial"}
        sx={{
          typography: { color: color },
        }}
      >
        {title}
        {Input}
      </Typography>
    </CustomButtonStyle>
  );
}
